const MODALS = {
  ADMIN_CLAUSE: 'AdminClauseModal',
  ADMIN_CREATE_TEMPLATE: 'AdminCreateTemplateModal',
};

export default MODALS;
